import axios from 'axios';
import React, {useContext} from 'react'
import { Controller, useForm,useFormState } from "react-hook-form";
import Select from 'react-select'
import Swal from 'sweetalert2';
import { VARIABLES } from '../../Constant';
import  secureLocalStorage  from  "react-secure-storage";
import swal from 'sweetalert';
import { PumpDetailsContext } from '../../Context/PumpDetailsContext';

const PumpManagementCreate = (props) => {
  // Secure Loacl Storage Stored Values
  const privileges = secureLocalStorage.getItem('privileges')
  const LoggedId = secureLocalStorage.getItem("loggedId")

  const {apiPumpDetails,
    apiPumpPlantOwnerDetails} = useContext(PumpDetailsContext);

  // React hook form 
  const { register, handleSubmit, watch, formState: { errors }, control,reset } = useForm();
  const { isDirty, isValid } = useFormState({
    control
  });

  // Onsubmit handler for to create a Pump 
  const onSubmit = (data) => {
    var pumpDetails = JSON.stringify({
      "name": data.name,
      "user_id": data.user_id.value,
      "location": data.location,
      "parent_id": data.parent_id.value,
      "node_id": props.selectedNode.value,
      "project_id": VARIABLES.project_id,
      "type": "pump",
      "pin_number" : data.pin_number.value,
      "mqtt_topic": `${VARIABLES.subdomain}/${VARIABLES.project_id}/${props.selectedNode.value}/reading/values/toggle_cmd`,
      "input_output": "O",
      "created_by_id" : LoggedId
    });
    
    console.log(pumpDetails)
    var config = {
      method: 'post',
      url: VARIABLES.url+"/api/entity-details",
      headers: {
        'Content-Type': 'application/json'
      },
      data: pumpDetails
    };

    axios(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        {privileges.includes("superadmin_admin") && swal({
          icon : "success",
          title: "Pump Created Successfully",
          showConfirmButton: false
        }).then(() => props.apiPumpDetails(),apiPumpDetails() )}

        {privileges.includes("plantowner") && swal({
          icon : "success",
          title: "Pump Created Successfully",
          showConfirmButton: false
        }).then(() => props.apiPumpPlantOwnerDetails(), apiPumpPlantOwnerDetails())}
      })
      .catch((error) => {
        console.log(error);
        if(error.response.status === 400) {
          swal({
            icon: 'error',
            title : "The Pin number is already taken for this node",
            text : error.response.data.message,
            showConfirmButton: false
          })
        } else {
          swal({
            icon: 'error',
            title: 'Failed to create Pump',
            showConfirmButton: false
          })
        }
      });
      reset();
      props.setSelectedNode("");
  };

  return (
    <>
      {/* <!-- Modal --> */}
      <div className="modal fade" id="addPump" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Create Pump</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className='mb-3'>
                  <label className="form-label">Name <span className="required_field">*</span></label>
                  <input className="form-control" type="text" placeholder="Enter the Pump Name" {...register("name", { required: true })}></input>
                  {errors.name && <span className='required_field'>Pump name is required</span>}
                </div>

                <div className="mb-3">
                  <label className="form-label">User <span className="required_field">*</span></label>
                  <Controller
                    render={({ field }) => <Select {...field} options={props.userdetails} />}
                    defaultValue=""
                    rules={{ required: true }}
                    name="user_id"
                    control={control} />
                    {errors.user_id && <span className='required_field'>User Id is required</span>}
                </div>

                <div className='mb-3'>
                  <label className="form-label">Location</label>
                  <input className="form-control" type="text" placeholder="Enter location" {...register("location")}></input>
                </div>

                <div className="mb-3">
                  <label className="form-label">Plant <span className="required_field">*</span></label>
                  <Controller
                    render={({ field }) => <Select {...field} options={props.plantDetails} />}
                    defaultValue=""
                    rules={{ required: true }}
                    name="parent_id"
                    control={control} />
                    {errors.parent_id && <span className='required_field'>Plant Id is required</span>}
                </div>

                <div className="mb-3">
                  <label className="form-label">Node Id <span className="required_field">*</span></label>
                  <Controller
                    render={({ field }) => <Select 
                    {...field} 
                    value={props.selectedNode}
                    onChange={(data) => {
                      props.setSelectedNode(data)
                      field.onChange(data)
                    }}
                    options={props.nodeData}
                    noOptionsMessage={() => 'No Nodes Avaliable.'} />}
                    defaultValue=""
                    rules={{ required: true }}
                    name="node_id"
                    control={control} />
                    {errors.node_id && <span className='required_field'>Node Id is required</span>}
                </div>

                <div className="mb-3">
                  <label className="form-label">Pin Number <span className="required_field">*</span></label>
                  <Controller
                    render={({ field }) => <Select {...field} 
                    options={props.options}
                    noOptionsMessage={() => 'No Pins Avaliable. Please select Node first'} />}
                    defaultValue=""
                    rules={{ required: true }}
                    name="pin_number"
                    control={control} />
                    {errors.pin_number && <span className='required_field'>Pin Number is required</span>}
                </div>

                <div className="modal-footer">
                  {/* <button type="submit" className="btn btn-primary">Submit</button> */}
                  {isValid === true ? <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">Submit</button> : <button type="submit" className="btn btn-primary">Submit</button>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PumpManagementCreate